import { useEffect, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import {
  clientBackOffice,
  clientCadastro,
  clientFunilObras,
  clientMapaMina,
  clientRoteirizacao,
  clientSimulador,
} from "../../services/utils/request";
import { loginRequest } from "../../config/authConfig";
import { db } from "~db/db";
import useOnlineStatus from "~hooks/useOnlineStatus";
import {
  InteractionRequiredAuthError,
} from "@azure/msal-browser";

export const useRequest = (setUseNoAuth) => {
  const isOnline = useOnlineStatus();
  const { instance, accounts } = useMsal();
  const contaRef = useRef();
  contaRef.current = accounts[0];

  useEffect(() => {
    const clients = [
      clientBackOffice,
      clientCadastro,
      clientMapaMina,
      clientSimulador,
      clientFunilObras,
      clientRoteirizacao,
    ];

    clients.forEach((client) => {
      client.interceptors.request.use(async (config) => {
        let dbToken = await db.token.get(1);
        const now = new Date();
        let shouldRefresh = false;

        if (dbToken) {
          const expiresOn = new Date(dbToken.expiresOn);
          const createdAt = new Date(dbToken.createdAt);
          const oneHourInMs = 60 * 60 * 1000
          shouldRefresh = now >= expiresOn || (now - createdAt) >= oneHourInMs;
        } else {
          shouldRefresh = true;
        }

        if (window.self !== window.top)
          console.log("App rodando dentro de iframe");

        if (shouldRefresh && isOnline) {
          console.log("Renovando o token...");
          let response = { accessToken: null, expiresOn: null };

          try {
            response = await instance.acquireTokenSilent({
              ...loginRequest,
              account: instance.getActiveAccount() ?? instance.getAllAccounts()[0],
            });

            console.log("Token renovado com sucesso.", response);
          } catch (error) {
            console.log("Erro ao renovar token:", error);

            try {
              console.log("Renovando o token com popup...");
              response = await instance.acquireTokenPopup(loginRequest);
              console.log("Token com popup renovado com sucesso.", response);
            }
            catch(popError) {
              console.log("Erro ao renovar token com popup:", popError);
              setUseNoAuth(true);
            }

            console.log("Response final:", response);
          }

          try {
            if (response.accessToken) {
              dbToken = {
                id: 1,
                accessToken: response.accessToken,
                expiresOn: response.expiresOn,
                createdAt: new Date()
              };
              await db.token.put(dbToken);
            }
          } catch (error) {
            console.log("Erro ao salvar token no db:", error);
          }
        }

        if (dbToken?.accessToken) {
          config.headers.Authorization = `Bearer ${dbToken.accessToken}`;
        } else {
          console.log("Token inválido ou ausente.");
        }

        const usuarioEmail = contaRef.current?.username;
        if (config.method === "get" && usuarioEmail) {
          config.params = { ...config.params, usuarioEmail };
        }

        return config;
      });
    });
  }, [instance]);
};